const Questions = [
  {
    id: 1,
    question: 'How often can you Donate Blood?',
    answer: 'One has to wait for 56 days or 8 weeks between whole blood donations. The waiting period is 112 days or 16 weeks between power red donations. Avoid donation if you’re suffering from any disorders, and consult your doctor before doing it.',
  },
  {
    id: 2,
    question: 'How much Blood do you Donate?',
    answer: 'You can donate one unit or 350 ml of blood every 8 weeks. Organizations such as American Red Cross organize donation camps where one can participate and donate blood. You can also donate blood at any hospital.',
  },
  {
    id: 3,
    question: 'How old do you have to be to Donate Blood?',
    answer: '17 YEARS OLD,Donors who have undergone acupuncture treatments are acceptable. You must be at least 17 years old to donate to the general blood supply, or 16 years old with parental/guardian consent, if allowed by state law.Donor’s age must be between 16-60 years and their weight should be more than 45 kgs to be able to donate blood. Any healthy person can donate blood after the required gap of 56 days. This wait time helps to replenish the blood levels in the donor’s body.',
  },
  {
    id: 4,
    question: 'How to Donate Bone Marrow?',
    answer: 'The first step towards bone marrow donation is sharing your details with bone marrow registers/websites. When a donation is needed, doctors would find the matching tissue type and contact you.',
  },
  {
    id: 5,
    question: 'How long does it take to recover from bone Marrow Donation?',
    answer: 'Bone Marrow and PBSC donors should expect to return to work, school and most other activities within 1 to 7 days. You’ll likely be able to get back to your normal routine within a couple of days. Your marrow will return to normal levels within a few weeks. It’s important to note that bone marrow donor recovery times will vary depending on the individual and the type of donation.',
  },
  {
    id: 6,
    question: 'Who cannot Donate Blood?',
    answer: 'Individuals below the age of 18 and above 60 and with weight lower than 110 lbs cannot donate blood. A person with active infection, acute infection or diseases like HIV AIDS should not donate blood. It is advisable to consult a doctor and share medical history before going for blood donation.',
  },



]
export default Questions;